import styles from './SpinnerComponent.module.css';

const SpinnerComponent = () => {

    return (
        <div className={styles.content}>
            <div className={styles.spinner}>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    )
}

export default SpinnerComponent;

